import styled from "styled-components";

import Bone from "./Bone";
import Card from "./Card";
import { CardFace2 } from "./CardFace";

const Styled = styled(CardFace2)`
    gap: 4px;
`;

export default function CardSkeleton() {
    return (
        <Card>
            <Styled>
                <Bone height="1.6rem" width="16rem" />
                <Bone height=".8rem" width="8rem" />
            </Styled>
        </Card>
    );
}
